function phoneFilter(num) {
  let country
  let city
  let number

  if (!num) {
    return ''
  }

  const value = num.toString().trim().replace(/^\+/, '')

  switch (value.length) {
    case 10: {
      country = 1
      city = value.slice(0, 3)
      number = value.slice(3)
      break
    }
    case 11: {
      country = value[0]
      city = value.slice(1, 4)
      number = value.slice(4)
      break
    }
    case 12: {
      country = value.slice(0, 2)
      city = value.slice(2, 5)
      number = value.slice(5)
      break
    }
    default: {
      return num
    }
  }

  if (country === 1) {
    country = ''
  } else {
    country = '+' + country
  }

  number = `${number.slice(0, 3)}-${number.slice(3)}`

  return `${country} (${city}) ${number}`.trim()
}

export { phoneFilter }
